"use strict";

var minisFancyContainer = document.querySelector('.minis-fancy');
var overlayElement = minisFancyContainer.querySelector('.overlay');
minisFancyContainer.addEventListener('mouseover', function () {
  overlayElement.classList.add('opacity-50');
});
minisFancyContainer.addEventListener('mouseleave', function () {
  overlayElement.classList.remove('opacity-50');
});
var showImage = function showImage(elm) {
  var elementsAbove = [elm];
  var prevElement = elm.previousElementSibling;
  while (prevElement) {
    elementsAbove.push(prevElement);
    prevElement = prevElement.previousElementSibling;
  }
  var elementsBelow = [];
  var nextElement = elm.nextElementSibling;
  while (nextElement) {
    elementsBelow.push(nextElement);
    nextElement = nextElement.nextElementSibling;
  }
  elementsBelow.forEach(function (elm) {
    return elm.classList.remove('opacity-100');
  });
  elementsAbove.forEach(function (elm) {
    return elm.classList.add('opacity-100');
  });
};
var items = minisFancyContainer.querySelectorAll('.mini-fancy');
items.forEach(function (item) {
  var image = minisFancyContainer.querySelector(".".concat(item.getAttribute('image')));
  item.addEventListener('mouseover', function () {
    showImage(image);
  });
});
//# sourceMappingURL=minisFancy.js.map